import { Component, OnInit } from '@angular/core';

@Component({
  templateUrl: './encuesta.component.html',
  styleUrls: ['./encuesta.component.scss']
})
export class EncuestaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
